import { render } from "./AIDigitalTransformation.vue?vue&type=template&id=30d20841&scoped=true"
import script from "./AIDigitalTransformation.vue?vue&type=script&lang=js"
export * from "./AIDigitalTransformation.vue?vue&type=script&lang=js"

import "./AIDigitalTransformation.vue?vue&type=style&index=0&id=30d20841&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d20841"]])

export default __exports__